import { useSupplier } from "./api/v2/supplier/useSupplier";
import { useRemoteFeatureFlags } from "./useRemoteFeatureFlags";
import { useSellarCurrentBusiness } from "./useSellarCurrentBusiness.shared";

export const useProductCatalogueMode = () => {
  const { business } = useSellarCurrentBusiness();
  const remoteFeatureFlags = useRemoteFeatureFlags();
  const basicModeFlagEnabled = remoteFeatureFlags.isActive(
    "basicProductCatalogueMode",
  );
  const supplierId = business?.Supplier?.id;
  const supplierQuery = useSupplier(supplierId, {
    enabled: basicModeFlagEnabled && !!supplierId,
  });

  return {
    isBasicMode:
      basicModeFlagEnabled &&
      supplierQuery.data?.advancedProductCataloguesEnabled === false,
    isAdvancedMode:
      !basicModeFlagEnabled ||
      supplierQuery.data?.advancedProductCataloguesEnabled === true,
    isLoading: basicModeFlagEnabled && supplierQuery.isLoading,
    modeAvailable: basicModeFlagEnabled,
    supplierQuery,
  };
};
